import { useState } from "react";
import { Card, CircularProgress, Backdrop } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import LogoutPageLayout from "layouts/logoutpage/LogoutPageLayout.js";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useForm } from 'react-hook-form';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import Config from "../../config.js";
import { useTranslation } from "react-i18next";

function ForgotPassword() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const BASE = Config.BASE;

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    await axios({
      url: BASE + "api/forgotPassword",
      method: "POST",
      data: { email: data.email },
      headers: {
        // Add any auth token here
        authorization: "no-token",
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (res) {
      setIsLoading(false);
      (res.status == 200 && res.data.status == 1) ?
        (
          toast.success(t(res.data.message))
        ) : (res.status == 200 && res.data.status == 0 && res.data.errors) ?
          (
            setError('email', {
              type: 'server',
              message: t(res.data.message)
            })
          ) : (
            toast.error(t('unexpectdError'))
          );
    }).catch(function (error) {
      setIsLoading(false);
    });
  };

  return (
    <LogoutPageLayout image={bgImage}>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>Forgot Password</MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
            <MDBox mb={2}>
              <MDInput type="email" name="email" label="Email" {...register("email", { required: true, pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ })} fullWidth />
              {errors.email && errors.email.type === "required" && (
                <p className="errorMsg">{t('emailRequired')}</p>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <p className="errorMsg">{t('emailNotValid')}</p>
              )}
              {errors.email && (
                <p className="errorMsg">{t(errors.email.message)}</p>
              )}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" disableRipple fullWidth>{t('submit')}</MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <ToastContainer position="top-center" />
    </LogoutPageLayout>
  );
}
export default ForgotPassword;
